var exports = {
  "uW": "VoiceActivitySection.module__section___RlFRWl",
  "eV": "VoiceActivitySection.module__moreCallsText___RlFRWl",
  "ti": "VoiceActivitySection.module__allCallsGrid___RlFRWl",
  "ux": "VoiceActivitySection.module__gridItem___RlFRWl",
};

module.exports = exports;
